import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'
import InputBase from '@material-ui/core/InputBase'
import Typography from '@material-ui/core/Typography'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import SearchIcon from '@material-ui/icons/Search'
import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import colorContext from '../../../../Context/colorContext'
import { useStyles } from './styles'

export default function Search(): JSX.Element {
  const { colors } = useContext(colorContext)
  const classes = useStyles({ colors })
  const history = useHistory()

  const [textSearch, setTextSearch] = useState<string>('')
  const [error, setError] = useState<string>('')
  const handleSearch = () => {
    if (textSearch.trim()) {
      const formattedSearchText = textSearch.replaceAll('/', '--')
      history.push(`/buscar/q=${formattedSearchText}`)
      setTextSearch('')
      setError('')
    } else {
      setError('Escreva um termo para buscar')
    }
  }

  const submitSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    handleSearch()
  }

  const trackSearch = () => {
    ;(window as any).gtag('event', 'screen_view', {
      app_name: 'Search',
      screen_name: 'Search',
    })
    ;(window as any).gtag('config', 'G-8YG8HLBNMX', {
      page_title: 'search',
      page_location: window.location.href,
      page_path: window.location.pathname,
    })
  }

  useEffect(() => {
    trackSearch()
  }, [])

  const handleChangeText = (value: string) => {
    const words = value.split(' ').length >= 1 && value.split(' ').length <= 15
    if (words) {
      setTextSearch(value)
      if (error) setError('')
    }
  }

  return (
    <div className={classes.main}>
      <Box className={classes.box}>
        <Box className={classes.titleContainer}>
          <Typography
            className={classes.titleSearch}
            variant="h3"
            component="h1"
          >
            Encontre um Serviço
          </Typography>
          <ArrowForwardIcon className={classes.arrowIcon} />
        </Box>
        <Box style={{ width: '100%', maxWidth: 720 }}>
          <form
            onSubmit={submitSearch}
            className={`${classes.formSearch} ${
              error ? classes.formSearchError : ''
            }`}
          >
            <div className={classes.boxInput}>
              <Box className={classes.iconButton}>
                <SearchIcon className={classes.iconSearch} />
              </Box>

              <InputBase
                value={textSearch}
                onChange={(e): void => handleChangeText(e.target.value)}
                className={`${classes.inputSearch} ${
                  error ? classes.inputError : ''
                }`}
                placeholder={error || 'Escreva aqui'}
              />
              <IconButton type="submit" className={classes.boxButtonSearch}>
                <Typography className={classes.buttonSearchText}>
                  Buscar
                </Typography>
              </IconButton>
            </div>
          </form>
        </Box>
        <Box
          onClick={(e: never) => submitSearch(e)}
          className={classes.buttonMobile}
        >
          <Typography className={classes.textSearchMobile}>buscar</Typography>
        </Box>
      </Box>
    </div>
  )
}
